import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, vModelRadio as _vModelRadio, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "w-full grid grid-cols-2 col-span-12 gap-x-4 mt-3 sm:mt-0" }
const _hoisted_3 = { class: "overflow-hidden relative rounded-lg bg-white shadow-sm col-span-2 sm:col-span-1" }
const _hoisted_4 = {
  key: 0,
  class: "fixed z-10 bottom-5 right-0 left-0 w-full flex items-center justify-center text-white text-sm"
}
const _hoisted_5 = { class: "bg-stone-800/90 backdrop-filter backdrop-blur-lg rounded-full shadow-md px-4 py-3 inline-flex items-center gap-2" }
const _hoisted_6 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_7 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_8 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_9 = {
  key: 0,
  class: "grid grid-cols-6 gap-6 mt-3"
}
const _hoisted_10 = { class: "col-span-full grid grid-cols-4 gap-6" }
const _hoisted_11 = { class: "col-span-4" }
const _hoisted_12 = {
  for: "cover-photo",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = { class: "flex gap-3" }
const _hoisted_15 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_16 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_17 = { class: "text-sm/6" }
const _hoisted_18 = {
  for: "title_color",
  class: "font-medium text-gray-900"
}
const _hoisted_19 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_20 = { class: "flex gap-3" }
const _hoisted_21 = { class: "flex h-6 shrink-0 items-center" }
const _hoisted_22 = { class: "group grid size-4 grid-cols-1" }
const _hoisted_23 = { class: "text-sm/6" }
const _hoisted_24 = {
  for: "subtitle_color",
  class: "font-medium text-gray-900"
}
const _hoisted_25 = { class: "col-span-6" }
const _hoisted_26 = { class: "flex grow flex-col ms-4" }
const _hoisted_27 = {
  key: 1,
  class: "col-span-6"
}
const _hoisted_28 = { class: "flex grow flex-col ms-4" }
const _hoisted_29 = { class: "col-span-6" }
const _hoisted_30 = { class: "relative mt-2" }
const _hoisted_31 = {
  key: 2,
  class: "col-span-6"
}
const _hoisted_32 = { class: "relative mt-2" }
const _hoisted_33 = { class: "col-span-6" }
const _hoisted_34 = { class: "w-full mb-3" }
const _hoisted_35 = { class: "block mb-2 font-medium" }
const _hoisted_36 = { class: "block mb-2 font-medium" }
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = ["id", "value"]
const _hoisted_40 = ["for"]
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = { class: "col-span-6 rounded-md border border-gray-200" }
const _hoisted_43 = { class: "flex border-b border-gray-200" }
const _hoisted_44 = { class: "hidden sm:block" }
const _hoisted_45 = { class: "hidden sm:block" }
const _hoisted_46 = { class: "grid grid-cols-6 gap-6 p-3" }
const _hoisted_47 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_48 = { class: "flex grow flex-col ms-4" }
const _hoisted_49 = {
  key: 1,
  class: "col-span-6"
}
const _hoisted_50 = { class: "flex grow flex-col ms-4" }
const _hoisted_51 = {
  key: 2,
  class: "col-span-6"
}
const _hoisted_52 = { class: "w-full mb-3" }
const _hoisted_53 = { class: "block mb-3 font-medium" }
const _hoisted_54 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_55 = ["id", "value"]
const _hoisted_56 = ["for"]
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = {
  key: 3,
  class: "col-span-6"
}
const _hoisted_59 = { class: "w-full mb-3" }
const _hoisted_60 = { class: "block mb-3 font-medium" }
const _hoisted_61 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_62 = ["id", "value"]
const _hoisted_63 = ["for"]
const _hoisted_64 = ["src", "alt"]
const _hoisted_65 = {
  key: 4,
  class: "col-span-6"
}
const _hoisted_66 = { class: "w-full mb-3" }
const _hoisted_67 = { class: "block mb-3 font-medium" }
const _hoisted_68 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_69 = ["id", "value"]
const _hoisted_70 = ["for"]
const _hoisted_71 = ["src", "alt"]
const _hoisted_72 = {
  key: 5,
  class: "col-span-6"
}
const _hoisted_73 = { class: "w-full mb-3" }
const _hoisted_74 = { class: "block mb-3 font-medium" }
const _hoisted_75 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_76 = ["id", "value"]
const _hoisted_77 = ["for"]
const _hoisted_78 = ["src", "alt"]
const _hoisted_79 = {
  key: 6,
  class: "col-span-6"
}
const _hoisted_80 = { class: "w-full mb-3" }
const _hoisted_81 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_82 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_83 = { class: "text-gray-500" }
const _hoisted_84 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_85 = { class: "text-gray-500" }
const _hoisted_86 = {
  key: 7,
  class: "col-span-6"
}
const _hoisted_87 = { class: "w-full mb-3" }
const _hoisted_88 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_89 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_90 = { class: "text-gray-500" }
const _hoisted_91 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_92 = { class: "text-gray-500" }
const _hoisted_93 = {
  key: 8,
  class: "col-span-6"
}
const _hoisted_94 = { class: "w-full mb-3" }
const _hoisted_95 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_96 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_97 = { class: "text-gray-500" }
const _hoisted_98 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_99 = { class: "text-gray-500" }
const _hoisted_100 = {
  key: 9,
  class: "col-span-6"
}
const _hoisted_101 = { class: "w-full mb-3" }
const _hoisted_102 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_103 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_104 = { class: "text-gray-500" }
const _hoisted_105 = { class: "block mb-1 text-sm font-medium" }
const _hoisted_106 = { class: "text-gray-500" }
const _hoisted_107 = { class: "col-span-6" }
const _hoisted_108 = {
  key: 0,
  class: "rounded-md bg-royal-blue-50 p-3 shadow-xs"
}
const _hoisted_109 = { class: "flex" }
const _hoisted_110 = { class: "shrink-0" }
const _hoisted_111 = { class: "ml-3 flex-1 md:flex md:justify-between" }
const _hoisted_112 = { class: "text-sm text-royal-blue-500" }
const _hoisted_113 = {
  key: 10,
  class: "col-span-6"
}
const _hoisted_114 = { class: "w-full mb-3" }
const _hoisted_115 = { class: "block mb-3 font-medium" }
const _hoisted_116 = ["aria-label"]
const _hoisted_117 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_118 = ["for"]
const _hoisted_119 = ["src", "alt"]
const _hoisted_120 = {
  key: 11,
  class: "col-span-6"
}
const _hoisted_121 = { class: "w-full mb-3" }
const _hoisted_122 = { class: "block mb-3 font-medium" }
const _hoisted_123 = ["aria-label"]
const _hoisted_124 = ["id", "value"]
const _hoisted_125 = ["for"]
const _hoisted_126 = ["src", "alt"]
const _hoisted_127 = {
  key: 12,
  class: "col-span-6"
}
const _hoisted_128 = { class: "w-full mb-3" }
const _hoisted_129 = { class: "block mb-1 font-medium" }
const _hoisted_130 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_131 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_132 = {
  key: 13,
  class: "col-span-6"
}
const _hoisted_133 = { class: "w-full mb-3" }
const _hoisted_134 = { class: "block mb-1 font-medium" }
const _hoisted_135 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_136 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_137 = { class: "col-span-6" }
const _hoisted_138 = { class: "w-full mb-3" }
const _hoisted_139 = { class: "block mb-1 font-medium" }
const _hoisted_140 = ["aria-label"]
const _hoisted_141 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_142 = ["for"]
const _hoisted_143 = ["src", "alt"]
const _hoisted_144 = { class: "col-span-1 hidden sm:block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_CoverUploaderComponent = _resolveComponent("CoverUploaderComponent")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_SwitchLabel = _resolveComponent("SwitchLabel")!
  const _component_SwitchDescription = _resolveComponent("SwitchDescription")!
  const _component_SwitchGroup = _resolveComponent("SwitchGroup")!
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ChevronUpDownIcon = _resolveComponent("ChevronUpDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_GalleryFrameComponent = _resolveComponent("GalleryFrameComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ControlsMenuComponent, { class: "sm:mb-6" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isUpdated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[29] || (_cache[29] = _createElementVNode("svg", {
                  class: "shrink-0 size-4 text-teal-500",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  fill: "currentColor",
                  viewBox: "0 0 16 16"
                }, [
                  _createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" })
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('gallery_design.changes_saved')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('gallery_design.title')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('gallery_design.description')), 1)
          ]),
          (_ctx.form.design)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('gallery_design.cover')), 1),
                    (_ctx.form.cover)
                      ? (_openBlock(), _createBlock(_component_CoverUploaderComponent, {
                          key: 0,
                          position: _ctx.form.cover.position,
                          cover_url: _ctx.form.cover.uploaded ? _ctx.form.cover.url : null,
                          preview_url: _ctx.cover.preview_url,
                          is_file_selected: _ctx.cover.file !== null,
                          is_file_uploading: _ctx.cover.is_uploading,
                          "allow-video": true,
                          onPositionUpdated: _ctx.coverPositionsUpdated,
                          onPositionUpdating: _ctx.coverPositionsUpdating,
                          onCoverFileSelected: _ctx.selectCoverFile
                        }, null, 8, ["position", "cover_url", "preview_url", "is_file_selected", "is_file_uploading", "onPositionUpdated", "onPositionUpdating", "onCoverFileSelected"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          id: "title_color",
                          "aria-describedby": "title_color-description",
                          name: "title_color",
                          type: "color",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.design.title_color) = $event)),
                          class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-royal-blue-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                        }, null, 512), [
                          [_vModelText, _ctx.form.design.title_color]
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("svg", {
                          class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                          viewBox: "0 0 14 14",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            class: "opacity-0 group-has-checked:opacity-100",
                            d: "M3 8L6 11L11 3.5",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-0 group-has-indeterminate:opacity-100",
                            d: "M3 7H11",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('gallery_design.title_color')), 1)
                    ])
                  ])
                ]),
                (_ctx.gallery.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              id: "subtitle_color",
                              "aria-describedby": "subtitle_color-description",
                              name: "subtitle_color",
                              type: "color",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.design.subtitle_color) = $event)),
                              class: "col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-blue-700 checked:bg-blue-700 indeterminate:border-royal-blue-600 indeterminate:bg-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            }, null, 512), [
                              [_vModelText, _ctx.form.design.subtitle_color]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('gallery_design.subtitle_color')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_SwitchGroup, {
                    as: "div",
                    class: "flex items-center justify-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Switch, {
                        modelValue: _ctx.form.design.show_title,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.design.show_title) = $event)),
                        class: _normalizeClass([_ctx.form.design.show_title ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: _normalizeClass([_ctx.form.design.show_title ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "class"]),
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_SwitchLabel, {
                          as: "span",
                          class: "text-sm/6 font-medium text-gray-900",
                          passive: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.show_title')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_SwitchDescription, {
                          as: "span",
                          class: "text-sm text-gray-500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.show_title_description')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.form.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_SwitchGroup, {
                        as: "div",
                        class: "flex items-center justify-between"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Switch, {
                            modelValue: _ctx.form.design.show_subtitle,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.design.show_subtitle) = $event)),
                            class: _normalizeClass([_ctx.form.design.show_subtitle ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                "aria-hidden": "true",
                                class: _normalizeClass([_ctx.form.design.show_subtitle ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                              }, null, 2)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "class"]),
                          _createElementVNode("span", _hoisted_28, [
                            _createVNode(_component_SwitchLabel, {
                              as: "span",
                              class: "text-sm/6 font-medium text-gray-900",
                              passive: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.show_subtitle')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_SwitchDescription, {
                              as: "span",
                              class: "text-sm text-gray-500"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.show_subtitle_description')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Listbox, {
                    as: "div",
                    modelValue: _ctx.form.design.title_font,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.design.title_font) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ListboxLabel, { class: "block text-sm/6 font-medium text-gray-900" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.title_font')), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ListboxButton, { class: "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(['col-start-1 row-start-1 truncate pr-6', 'font-item', _ctx.form.design.title_font])
                            }, _toDisplayString(_ctx.fonts[_ctx.form.design.title_font]), 3),
                            _createVNode(_component_ChevronUpDownIcon, {
                              class: "col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_Transition, {
                          "leave-active-class": "transition ease-in duration-100",
                          "leave-from-class": "opacity-100",
                          "leave-to-class": "opacity-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fonts, (title, key) => {
                                  return (_openBlock(), _createBlock(_component_ListboxOption, {
                                    as: "template",
                                    key: key,
                                    value: key
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("li", {
                                        class: _normalizeClass([key == _ctx.form.design.title_font ? 'bg-royal-blue-600 text-white outline-hidden' : 'text-gray-900', 'relative cursor-default py-2 pr-9 pl-3 select-none'])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass([key == _ctx.form.design.title_font ? 'font-semibold' : 'font-normal', 'block truncate', 'font-item', key])
                                        }, _toDisplayString(title), 3),
                                        (key == _ctx.form.design.title_font)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass([key == _ctx.form.design.title_font ? 'text-white' : 'text-royal-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                            }, [
                                              _createVNode(_component_CheckIcon, {
                                                class: "size-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_ctx.gallery.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_Listbox, {
                        as: "div",
                        modelValue: _ctx.form.design.subtitle_font,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.design.subtitle_font) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ListboxLabel, { class: "block text-sm/6 font-medium text-gray-900" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.subtitle_font')), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_ListboxButton, { class: "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['col-start-1 row-start-1 truncate pr-6', 'font-item', _ctx.form.design.subtitle_font])
                                }, _toDisplayString(_ctx.fonts[_ctx.form.design.subtitle_font]), 3),
                                _createVNode(_component_ChevronUpDownIcon, {
                                  class: "col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, {
                              "leave-active-class": "transition ease-in duration-100",
                              "leave-from-class": "opacity-100",
                              "leave-to-class": "opacity-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fonts, (title, key) => {
                                      return (_openBlock(), _createBlock(_component_ListboxOption, {
                                        as: "template",
                                        key: key,
                                        value: key
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("li", {
                                            class: _normalizeClass([key == _ctx.form.design.subtitle_font ? 'bg-royal-blue-600 text-white outline-hidden' : 'text-gray-900', 'relative cursor-default py-2 pr-9 pl-3 select-none'])
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass([key == _ctx.form.design.subtitle_font ? 'font-semibold' : 'font-normal', 'block truncate', 'font-item', key])
                                            }, _toDisplayString(title), 3),
                                            (key == _ctx.form.design.subtitle_font)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: _normalizeClass([key == _ctx.form.design.subtitle_font ? 'text-white' : 'text-royal-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                                }, [
                                                  _createVNode(_component_CheckIcon, {
                                                    class: "size-5",
                                                    "aria-hidden": "true"
                                                  })
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('gallery_design.cover_design')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: "flex gap-2",
                        role: "group",
                        "aria-label": _ctx.$t('gallery_design.cover_design')
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverTypes, (cover) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: cover.value
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "cover_type",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.design.cover_type) = $event)),
                              id: cover.value,
                              value: cover.value,
                              class: "hidden"
                            }, null, 8, _hoisted_39), [
                              [_vModelRadio, _ctx.form.design.cover_type]
                            ]),
                            _createElementVNode("label", {
                              for: cover.value,
                              class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.cover_type == cover.value})
                            }, [
                              _createElementVNode("img", {
                                src: cover.img,
                                alt: cover.label,
                                class: "w-16 h-16 object-cover rounded-md"
                              }, null, 8, _hoisted_41)
                            ], 10, _hoisted_40)
                          ], 64))
                        }), 128))
                      ], 8, _hoisted_38)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.isDesktop = true), ["prevent"])),
                      class: _normalizeClass({'w-full flex justify-center items-center gap-2 cursor-pointer text-center border-b-2 px-4 py-4 text-sm font-medium whitespace-nowrap': true, 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700': !_ctx.isDesktop, 'border-royal-blue-500 text-royal-blue-600': _ctx.isDesktop})
                    }, [
                      _cache[31] || (_cache[31] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-pc-display",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M8 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm1 13.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0m2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0M9.5 1a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM9 3.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H6v2h-.5a.5.5 0 0 0 0 1H7v-4H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H7V2z" })
                      ], -1)),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('gallery_design.desktop_version')), 1)
                    ], 2),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.isDesktop = false), ["prevent"])),
                      class: _normalizeClass({'w-full flex justify-center items-center gap-2 cursor-pointer text-center border-b-2 px-4 py-4 text-sm font-medium whitespace-nowrap': true, 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700': _ctx.isDesktop, 'border-royal-blue-500 text-royal-blue-600': !_ctx.isDesktop})
                    }, [
                      _cache[32] || (_cache[32] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-phone",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" }),
                        _createElementVNode("path", { d: "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
                      ], -1)),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('gallery_design.mobile_version')), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createVNode(_component_SwitchGroup, {
                            as: "div",
                            class: "flex items-center justify-between"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Switch, {
                                modelValue: _ctx.form.design.is_rounded_photos,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.design.is_rounded_photos) = $event)),
                                class: _normalizeClass([_ctx.form.design.is_rounded_photos ? 'bg-royal-blue-500' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-500 focus:ring-offset-2 focus:outline-hidden'])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    "aria-hidden": "true",
                                    class: _normalizeClass([_ctx.form.design.is_rounded_photos ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"]),
                              _createElementVNode("span", _hoisted_48, [
                                _createVNode(_component_SwitchLabel, {
                                  as: "span",
                                  class: "text-sm/6 font-medium text-gray-900",
                                  passive: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.rounded_photos')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_SwitchDescription, {
                                  as: "span",
                                  class: "text-sm text-gray-500"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.rounded_photos_description')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createVNode(_component_SwitchGroup, {
                            as: "div",
                            class: "flex items-center justify-between"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Switch, {
                                modelValue: _ctx.form.design.is_rounded_photos_mobile,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.design.is_rounded_photos_mobile) = $event)),
                                class: _normalizeClass([_ctx.form.design.is_rounded_photos_mobile ? 'bg-royal-blue-500' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-500 focus:ring-offset-2 focus:outline-hidden'])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    "aria-hidden": "true",
                                    class: _normalizeClass([_ctx.form.design.is_rounded_photos_mobile ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white ring-0 shadow-sm transition duration-200 ease-in-out'])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"]),
                              _createElementVNode("span", _hoisted_50, [
                                _createVNode(_component_SwitchLabel, {
                                  as: "span",
                                  class: "text-sm/6 font-medium text-gray-900",
                                  passive: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.rounded_photos')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_SwitchDescription, {
                                  as: "span",
                                  class: "text-sm text-gray-500"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.rounded_photos_description')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (['without', 'full'].includes(_ctx.form.design.cover_type) && _ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('gallery_design.title_position')), 1),
                            _createElementVNode("div", _hoisted_54, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['top-left','top-center','top-right','center-left','center','center-right','bottom-left','bottom-center','bottom-right'], (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `title_cover_position-item-${item}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "title_cover_position",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.design.title_cover_position) = $event)),
                                    id: `title_cover_position-input-${item}`,
                                    value: item,
                                    class: "hidden"
                                  }, null, 8, _hoisted_55), [
                                    [_vModelRadio, _ctx.form.design.title_cover_position]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `title_cover_position-input-${item}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.title_cover_position == item})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/title-position/${item}.png`),
                                      alt: item,
                                      class: "w-full object-cover"
                                    }, null, 8, _hoisted_57)
                                  ], 10, _hoisted_56)
                                ], 64))
                              }), 64))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (['small', 'small-without'].includes(_ctx.form.design.cover_type) && _ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('gallery_design.title_position')), 1),
                            _createElementVNode("div", _hoisted_61, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['center-left','center','center-right'], (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `title_cover_position-item-${item}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "title_cover_position",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.design.title_cover_position) = $event)),
                                    id: `title_cover_position-input-${item}`,
                                    value: item,
                                    class: "hidden"
                                  }, null, 8, _hoisted_62), [
                                    [_vModelRadio, _ctx.form.design.title_cover_position]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `title_cover_position-input-${item}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.title_cover_position == item})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/title-position/${item}.png`),
                                      alt: item,
                                      class: "w-full object-cover"
                                    }, null, 8, _hoisted_64)
                                  ], 10, _hoisted_63)
                                ], 64))
                              }), 64))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (['without', 'full'].includes(_ctx.form.design.cover_type) && !_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('gallery_design.title_position')), 1),
                            _createElementVNode("div", _hoisted_68, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['top-left','top-center','top-right','center-left','center','center-right','bottom-left','bottom-center','bottom-right'], (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `title_cover_position-item-${item}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "title_cover_position",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.design.title_cover_position_mobile) = $event)),
                                    id: `title_cover_position-input-${item}`,
                                    value: item,
                                    class: "hidden"
                                  }, null, 8, _hoisted_69), [
                                    [_vModelRadio, _ctx.form.design.title_cover_position_mobile]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `title_cover_position-input-${item}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.title_cover_position_mobile == item})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/title-position/${item}.png`),
                                      alt: item,
                                      class: "w-full object-cover"
                                    }, null, 8, _hoisted_71)
                                  ], 10, _hoisted_70)
                                ], 64))
                              }), 64))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (['small', 'small-without'].includes(_ctx.form.design.cover_type) && !_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('gallery_design.title_position')), 1),
                            _createElementVNode("div", _hoisted_75, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['center-left','center','center-right'], (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `title_cover_position-item-${item}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "title_cover_position",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.design.title_cover_position_mobile) = $event)),
                                    id: `title_cover_position-input-${item}`,
                                    value: item,
                                    class: "hidden"
                                  }, null, 8, _hoisted_76), [
                                    [_vModelRadio, _ctx.form.design.title_cover_position_mobile]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `title_cover_position-input-${item}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.title_cover_position_mobile == item})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/title-position/${item}.png`),
                                      alt: item,
                                      class: "w-full object-cover"
                                    }, null, 8, _hoisted_78)
                                  ], 10, _hoisted_77)
                                ], 64))
                              }), 64))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_82, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.title_font_size')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.form.design.title_font_size), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "10",
                                  max: "180",
                                  step: "5",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.design.title_font_size) = $event)),
                                  id: "title_font_size",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${((_ctx.form.design.title_font_size - 10) / 170) * 100}% - 1%), #e5e7eb calc(${((_ctx.form.design.title_font_size - 10) / 170) * 100}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.title_font_size]
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_84, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.subtitle_font_size')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.form.design.subtitle_font_size), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "5",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.design.subtitle_font_size) = $event)),
                                  id: "subtitle_font_size",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${((_ctx.form.design.subtitle_font_size - 5) / 95 * 100)}% - 1%), #e5e7eb calc(${((_ctx.form.design.subtitle_font_size - 5) / 95 * 100)}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.subtitle_font_size]
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_89, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.title_font_size')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.form.design.title_font_size_mobile), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "10",
                                  max: "180",
                                  step: "5",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.design.title_font_size_mobile) = $event)),
                                  id: "title_font_size_mobile",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${((_ctx.form.design.title_font_size_mobile - 10) / 170) * 100}% - 1%), #e5e7eb calc(${((_ctx.form.design.title_font_size_mobile - 10) / 170) * 100}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.title_font_size_mobile]
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_91, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.subtitle_font_size')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.form.design.subtitle_font_size_mobile), 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "5",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.design.subtitle_font_size_mobile) = $event)),
                                  id: "subtitle_font_size_mobile",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${((_ctx.form.design.subtitle_font_size_mobile - 5) / 95 * 100)}% - 1%), #e5e7eb calc(${((_ctx.form.design.subtitle_font_size_mobile - 5) / 95 * 100)}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.subtitle_font_size_mobile]
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!['without'].includes(_ctx.form.design.cover_type) && _ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_96, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.gradient_opacity')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_97, _toDisplayString(100 - _ctx.form.design.gradient_opacity_percent) + "%", 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.design.gradient_opacity_percent) = $event)),
                                  id: "gradient_opacity_percent",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${_ctx.form.design.gradient_opacity_percent}% - 1%), #e5e7eb calc(${_ctx.form.design.gradient_opacity_percent}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.gradient_opacity_percent]
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_98, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.gradient_fill')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.form.design.gradient_fill_percent) + "%", 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.design.gradient_fill_percent) = $event)),
                                  id: "gradient_fill_percent",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${_ctx.form.design.gradient_fill_percent}% - 1%), #e5e7eb calc(${_ctx.form.design.gradient_fill_percent}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.gradient_fill_percent]
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!['without'].includes(_ctx.form.design.cover_type) && !_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_103, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.gradient_opacity')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_104, _toDisplayString(100 - _ctx.form.design.gradient_opacity_percent_mobile) + "%", 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.design.gradient_opacity_percent_mobile) = $event)),
                                  id: "gradient_opacity_percent_mobile",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${_ctx.form.design.gradient_opacity_percent_mobile}% - 1%), #e5e7eb calc(${_ctx.form.design.gradient_opacity_percent_mobile}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.gradient_opacity_percent_mobile]
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_105, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.gradient_fill')) + " - ", 1),
                                  _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.form.design.gradient_fill_percent_mobile) + "%", 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.design.gradient_fill_percent_mobile) = $event)),
                                  id: "gradient_fill_percent_mobile",
                                  class: "w-full appearance-none h-2 rounded-lg",
                                  style: _normalizeStyle({
                                                      background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${_ctx.form.design.gradient_fill_percent_mobile}% - 1%), #e5e7eb calc(${_ctx.form.design.gradient_fill_percent_mobile}% + 1%), #e5e7eb 100%)`
                                                    })
                                }, null, 4), [
                                  [_vModelText, _ctx.form.design.gradient_fill_percent_mobile]
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_107, [
                      (_ctx.isDesktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("div", _hoisted_110, [
                                _createVNode(_component_InformationCircleIcon, {
                                  class: "size-5 text-royal-blue-500",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.$t('gallery_design.info')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('gallery_design.photos_per_row')), 1),
                            _createElementVNode("div", {
                              class: "flex gap-2",
                              role: "group",
                              "aria-label": _ctx.$t('gallery_design.photos_per_row')
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layouts, (layout) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: layout.value
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "layout",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.design.layout) = $event),
                                    onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.reloadFrames && _ctx.reloadFrames(...args))),
                                    id: `layout_${layout.value}`,
                                    value: layout.value,
                                    class: "hidden"
                                  }, null, 40, _hoisted_117), [
                                    [_vModelRadio, _ctx.form.design.layout]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `layout_${layout.value}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.layout == layout.value})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/layout-${layout.value}.png`),
                                      alt: layout.value,
                                      class: "w-12 h-12 object-cover rounded-md"
                                    }, null, 8, _hoisted_119)
                                  ], 10, _hoisted_118)
                                ], 64))
                              }), 128))
                            ], 8, _hoisted_116)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t('gallery_design.photos_per_row')), 1),
                            _createElementVNode("div", {
                              class: "flex gap-2",
                              role: "group",
                              "aria-label": _ctx.$t('gallery_design.photos_per_row')
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layouts, (layout) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: layout.value
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "layout",
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.design.layout_mobile) = $event)),
                                    onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.reloadFrames && _ctx.reloadFrames(...args))),
                                    id: `layout_${layout.value}`,
                                    value: layout.value,
                                    class: "hidden"
                                  }, null, 40, _hoisted_124), [
                                    [_vModelRadio, _ctx.form.design.layout_mobile]
                                  ]),
                                  _createElementVNode("label", {
                                    for: `layout_${layout.value}`,
                                    class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.layout_mobile == layout.value})
                                  }, [
                                    _createElementVNode("img", {
                                      src: require(`@/assets/images/gallery-design/layout-${layout.value}.png`),
                                      alt: layout.value,
                                      class: "w-12 h-12 object-cover rounded-md"
                                    }, null, 8, _hoisted_126)
                                  ], 10, _hoisted_125)
                                ], 64))
                              }), 128))
                            ], 8, _hoisted_123)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("label", _hoisted_129, [
                              _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.photo_spacing')) + " - ", 1),
                              (_ctx.form.design.padding == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(_ctx.$t('gallery_design.no_spacing')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString(_ctx.form.design.padding), 1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "range",
                              min: "0",
                              max: "50",
                              step: "1",
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.design.padding) = $event)),
                              id: "padding",
                              class: "w-full appearance-none h-2 rounded-lg",
                              style: _normalizeStyle({
                                        background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${(_ctx.form.design.padding / 50) * 100}% - 1%), #e5e7eb calc(${(_ctx.form.design.padding / 50) * 100}% + 1%), #e5e7eb 100%)`
                                    })
                            }, null, 4), [
                              [_vModelText, _ctx.form.design.padding]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _createElementVNode("label", _hoisted_134, [
                              _createTextVNode(_toDisplayString(_ctx.$t('gallery_design.photo_spacing')) + " - ", 1),
                              (_ctx.form.design.padding_mobile == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(_ctx.$t('gallery_design.no_spacing')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_136, _toDisplayString(_ctx.form.design.padding_mobile), 1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "range",
                              min: "0",
                              max: "50",
                              step: "1",
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.design.padding_mobile) = $event)),
                              id: "padding_mobile",
                              class: "w-full appearance-none h-2 rounded-lg",
                              style: _normalizeStyle({
                                        background: `linear-gradient(to right, #2563eb 0%, #2563eb calc(${(_ctx.form.design.padding_mobile / 50) * 100}% - 1%), #e5e7eb calc(${(_ctx.form.design.padding_mobile / 50) * 100}% + 1%), #e5e7eb 100%)`
                                    })
                            }, null, 4), [
                              [_vModelText, _ctx.form.design.padding_mobile]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.$t('gallery_design.theme')), 1),
                    _createElementVNode("div", {
                      class: "flex gap-2",
                      role: "group",
                      "aria-label": _ctx.$t('gallery_design.theme')
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: theme.value
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "theme",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.design.theme) = $event),
                            onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.reloadFrames && _ctx.reloadFrames(...args))),
                            id: `theme_${theme.value}`,
                            value: theme.value,
                            class: "hidden"
                          }, null, 40, _hoisted_141), [
                            [_vModelRadio, _ctx.form.design.theme]
                          ]),
                          _createElementVNode("label", {
                            for: `theme_${theme.value}`,
                            class: _normalizeClass({'cursor-pointer rounded-md hover:scale-105 transition duration-300': true, 'border-blue-670 ring-2 ring-blue-700 scale-105': _ctx.form.design.theme == theme.value})
                          }, [
                            _createElementVNode("img", {
                              src: require(`@/assets/images/gallery-design/theme-${theme.value}.png`),
                              alt: theme.value,
                              class: "w-16 h-16 object-cover rounded-md"
                            }, null, 8, _hoisted_143)
                          ], 10, _hoisted_142)
                        ], 64))
                      }), 128))
                    ], 8, _hoisted_140)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_144, [
        (_ctx.isCurrentGallery)
          ? (_openBlock(), _createBlock(_component_GalleryFrameComponent, {
              key: 0,
              "frame-url": _ctx.gallery.frame_url,
              ref: "gallery-frame"
            }, null, 8, ["frame-url"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}